module.exports = __webpack_public_path__ + "img/a5c6b34d4cd7be51ad38724535c401eb.a11e0b26.png";